var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ItpFormSelect2", {
    attrs: {
      name: _vm.fieldName,
      "bind-object": "",
      options: _vm.projects,
      valueField: "id",
      textField: "name",
      clearable: _vm.clearable,
      readonly: _vm.item.isReadonly
    },
    on: {
      optionSelected: function($event) {
        return _vm.evh_7315092382398562_optionSelected($event, {})
      }
    },
    model: {
      value: _vm.item[_vm.fieldName],
      callback: function($$v) {
        _vm.$set(_vm.item, _vm.fieldName, $$v)
      },
      expression: "item[fieldName]"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }